import * as filters from "@/utils/filters.js";

//注册全局指令
export function registerGlobFilter(app) {
  Object.keys(filters).forEach((key) => {
    app.filter(key, filters[key]);
  });
}
